import { useEffect, useState } from "react";
import { motion } from "framer-motion";

export default function ProjectCard({
  project,
  index,
  onOpen,
}) {
  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) =>
        (prev + 1) % project.images.length
      );
    }, 5000);

    return () => clearInterval(interval);
  }, [project.images.length]);

  return (
    <motion.button
      onClick={onOpen}
      initial={{ opacity: 0, y: 25 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{
        duration: 0.6,
        delay: index * 0.08,
      }}
      className="group text-left bg-white overflow-hidden shadow-sm hover:shadow-xl transition-all duration-500"
    >
      <div className="relative overflow-hidden aspect-[4/3]">

        <img
          src={project.images[currentImage]}
          alt={project.title}
          className="w-full h-full object-cover transition-all duration-1000 group-hover:scale-105"
        />

        <div className="absolute inset-0 bg-black/10 group-hover:bg-black/25 transition-all duration-500" />

        <div className="absolute top-4 left-4 bg-white/95 backdrop-blur px-3 py-1 font-display text-[10px] tracking-[0.22em] uppercase text-persia-black">
          {String(index + 1).padStart(2, "0")}
        </div>

        {/* Indicadores */}

        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
          {project.images.map((_, i) => (
            <span
              key={i}
              className={`w-2 h-2 rounded-full transition-all duration-300 ${
                currentImage === i
                  ? "bg-gold"
                  : "bg-white/60"
              }`}
            />
          ))}
        </div>

      </div>

      <div className="p-6">
        <h3 className="font-display text-xl font-semibold text-persia-black">
          {project.title}
        </h3>

        <p className="mt-2 text-persia text-sm font-light">
          {project.subtitle}
        </p>
      </div>
    </motion.button>
  );
}